import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('SmartBouffe Error:', error, errorInfo);
  }

  handleRetry = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      const { error } = this.state;
      const errorMessage = error?.message || 'Erreur inconnue';
      const stackLines = (error?.stack || '').split('\n').slice(0, 3).join('\n');

      return (
        <div data-testid="error-boundary" style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', height: '100vh', padding: '2rem',
          background: '#F5F1E8', fontFamily: 'system-ui, sans-serif'
        }}>
          <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🍳</div>
          <h2 style={{ color: '#5D6F61', marginBottom: '0.5rem', fontSize: '1.3rem' }}>
            Oups, petit pépin en cuisine!
          </h2>
          <p style={{ color: '#8B7355', marginBottom: '1.5rem', textAlign: 'center', maxWidth: '300px' }}>
            Une erreur est survenue.
          </p>
          <button
            data-testid="error-retry-button"
            onClick={this.handleRetry}
            style={{
              padding: '0.8rem 2rem', background: '#87A96B', color: 'white',
              border: 'none', borderRadius: '12px', fontSize: '1rem',
              fontWeight: '600', cursor: 'pointer'
            }}
          >
            Réessayer
          </button>
          <div style={{
            marginTop: '1.5rem', padding: '0.75rem', background: '#EDE9E0',
            borderRadius: '8px', maxWidth: '400px', width: '100%', overflow: 'auto'
          }}>
            <p style={{ color: '#999', fontSize: '0.7rem', margin: '0 0 0.3rem 0', fontWeight: '600' }}>
              {errorMessage}
            </p>
            <pre style={{
              color: '#aaa', fontSize: '0.6rem', margin: 0,
              whiteSpace: 'pre-wrap', wordBreak: 'break-all'
            }}>
              {stackLines}
            </pre>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
